import React, { ReactNode } from 'react';

import { Paper, PaperProps, Stack, Typography } from '@mui/material';

import { useVisibility, VisibilityProps } from '../store/use-visibility';

export type ControlBoxProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  fullWidth?: boolean;
  size?: 'normal' | 'tall';
} & Omit<PaperProps, 'title'> &
  VisibilityProps;

type Props = {
  control?: ReactNode;
} & ControlBoxProps;

export const ControlBox = ({
  title,
  subtitle,
  fullWidth,
  size = 'normal',
  visibility,
  control,
  ...props
}: Props) => {
  if (!useVisibility(visibility)) return null;

  return (
    <Paper
      {...props}
      sx={{
        height: size === 'tall' ? 100 : 'auto',
        width: fullWidth ? '100%' : 240,
        minWidth: fullWidth ? '100%' : 240,
        display: 'flex',
        flexDirection: 'column',
        ...(props.sx || {}),
      }}
    >
      <Stack direction="row" alignItems="center">
        <Typography variant="h3" sx={{ mr: 'auto' }}>
          {title}
        </Typography>
        {control}
      </Stack>

      {subtitle && (
        <Typography
          variant="h5"
          sx={{ mt: size === 'tall' ? 'auto' : 0, color: 'primary.main' }}
        >
          {subtitle}
        </Typography>
      )}
    </Paper>
  );
};
